<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view  v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view  v-if="!$route.meta.keepAlive"/>-->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  mounted() {
    // const script = document.createElement("script");
    // script.src =
    //   "https://s4.cnzz.com/z_stat.php?id=1279044947&web_id=1279044947";
    // script.language = "JavaScript";
    // document.body.appendChild(script);
  },
  watch: {
    $route() {
      // if (window._czc) {
      //   let location = window.location;
      //   let contentUrl = location.pathname + location.hash;
      //   let refererUrl = "/";
      //   window._czc.push(["_trackPageview", contentUrl, refererUrl]);
      // }
    }
  }
};
</script>

<style lang="scss">
@import "/assets/css/scss/cssrem";

#app {
  // font-family: Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB",
  //   "Heiti SC", STXihei, "Microsoft YaHei", SimHei, "WenQuanYi Micro Hei";
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  color: #333333;
  height: 100%;
  position: relative;
}
* {
  margin: 0px;
  padding: 0px;
  text-decoration: none;
  list-style: none;
}
html {
  height: 100%;
}
body {
  height: 100%;
  overflow-x: hidden;
}
h1,
h2,
h3,
h4,
h5,
h6,
ul,
li,
dl,
dt,
dd,
p,
img,
input,
button,
textarea,
select {
  margin: 0;
  padding: 0;
  list-style: none;
}

a {
  color: #333333;
  text-decoration: none; /* 重置链接a标签 */
  &:active,
  &:hover {
    text-decoration: none;
  } /* 重置链接a标签的鼠标滑动效果 */
}
//下拉滚动样式
.mescroll-downwarp .downwarp-tip,
.mescroll-upwarp .upwarp-tip {
  font-size: px2rem(30px) !important;
}
.mescroll-totop {
  bottom: px2rem(120px) !important;
  width: px2rem(66px) !important;
  height: px2rem(66px) !important;
}
.upwarp-nodata {
  font-size: px2rem(26px) !important;
}

.title-top {
  text-align: center;
  font-size: px2rem(35px);
}
.title-product {
  padding: px2rem(10px);
  font-size: px2rem(35px) !important;
  font-weight: bold;
  text-align: center;
  color: #65cacb;
}

//搜索框的样式
.mescroll {
  top: px2rem(85px) !important;
}
.mint-search {
  height: px2rem(118px);
  padding: px2rem(8px);
}
.mint-search-list {
  padding-top: 0 !important;
  position: unset !important;
}
.mint-searchbar {
  padding: px2rem(8px) px2rem(10px) !important;
}
.mint-searchbar-inner {
  height: px2rem(48px) !important;
  padding: px2rem(4px) px2rem(6px) !important;
}
.mint-searchbar-inner .mintui-search {
  font-size: px2rem(35px) !important;
}
.mint-searchbar-core {
  font-size: px2rem(30px);
}
.mint-searchbar-cancel {
  font-size: px2rem(25px);
}

//富文本框样式
.vue-html5-editor {
  border: 0;
  pointer-events: none;
}
#htmltest img {
  width: 100%;
  border: 0;
}

//Toast弹框样式
.mint-toast-text {
  font-size: px2rem(32px) !important;
}

//
.mint-swipe {
  height: px2rem(500px) !important;
}
.mint-swipe-indicator {
  width: px2rem(15px) !important;
  height: px2rem(15px) !important;
  margin-left: px2rem(5px) !important;
  margin-right: px2rem(5px) !important;

  opacity: 0.5 !important;
}
.mint-swipe-indicators {
  left: 90% !important;
}
.mint-swipe-indicator.is-active {
  background: #006f53 !important;
}

.el-upload--picture-card {
  border: px2rem(3px) dashed #c0ccda !important;
  width: px2rem(148px) !important;
  height: px2rem(148px) !important;
  line-height: px2rem(60px) !important;
}
.el-upload--picture-card i {
  font-size: px2rem(48px) !important;
  line-height: px2rem(138px) !important;
}
.el-upload-list--picture-card {
  width: px2rem(148px) !important;
  height: px2rem(148px) !important;
}
.el-upload-list--picture-card .el-upload-list__item {
  width: px2rem(148px) !important;
  height: px2rem(148px) !important;
}
.el-upload-list__item-actions {
  font-size: px2rem(30px) !important;
  opacity: 1 !important;
}
.el-upload-list__item-actions span {
  display: inline-block !important;
  margin: px2rem(20px);
}
.el-dialog__headerbtn {
  font-size: px2rem(30px) !important;
  margin-right: px2rem(14px) !important;
}
.el-dialog--tiny {
  width: 100% !important;
}
.el-dialog__title {
  font-size: px2rem(30px) !important;
}

.mint-tab-item-label {
  line-height: px2rem(65px) !important;
  font-size: px2rem(34px) !important;
}
.mint-tabbar > .mint-tab-item.is-selected {
  background-color: #fafafa !important;
  color: #006f53 !important;
}

//确认框
.mint-msgbox-title {
  font-size: px2rem(35px) !important;
}
.mint-msgbox-message {
  font-size: px2rem(30px);
  line-height: px2rem(69px) !important;
}
.mint-msgbox-content {
  min-height: px2rem(60px) !important;
}
.mint-msgbox-btns {
  height: px2rem(60px) !important;
}
.mint-msgbox-btn {
  font-size: px2rem(30px);
  line-height: px2rem(65px) !important;
}

///mint ui  弹框
.mint-msgbox-message {
  display: none !important;
}
.mint-msgbox-input input {
  font-size: px2rem(34px);
}

//王涛选择框
.el-input__inner {
  border: 0;
}
.wtselect {
  width: px2rem(560px);
  height: px2rem(70px);
  font-size: px2rem(30px);
  border-radius: px2rem(4px);
  border: px2rem(2px) solid #dcdfe6;
  box-sizing: border-box;
  .el-input {
    height: px2rem(70px);
  }
  input {
    height: px2rem(70px);
    font-size: px2rem(30px);
  }
}
.el-select-dropdown__item {
  height: px2rem(60px) !important;
  span {
    font-size: px2rem(30px);
  }
}
.el-select-dropdown__empty {
  font-size: px2rem(30px) !important;
}
.el-autocomplete-suggestion li {
  line-height: px2rem(36px) !important;
  font-size: px2rem(32px) !important;
}
.el-autocomplete-suggestion__wrap {
  max-height: px2rem(710px) !important;
}

.pdfjs .pageNum span{
  font-size: 26px !important;
}

.pdfjs .pageNum {
  height: 36px !important;
}
.pdfjs .pageNum-num {
  line-height: 36px !important;
}
// .pswp__top-bar {
//   height: px2rem(70px) !important;
// }
// .pswp__button--close {
//   top: px2rem(-80px);
//   right: px2rem(8px);
//   height: px2rem(90px) !important;
//   width: px2rem(90px) !important;
//    background-image: url(./assets/zoom2.png) !important;
// }
// .pswp__button--zoom {
//   top: px2rem(-28px) !important;
//   left: px2rem(-28px) !important;
//   height: px2rem(90px) !important;
//   width: px2rem(90px) !important;
//   background-image: url(./assets/zoom.png) !important;
// }
</style>



// WEBPACK FOOTER //
// App.vue?f24f2e52